export const UPDATE_BROWSER_TITLE = 'UPDATE_BROWSER_TITLE';
